export default __webpack_public_path__ + "static/media/Group 330.f44e9c60.png";